import React, { useState, useEffect, useMemo } from "react";
import { TextField, Autocomplete, CircularProgress } from "@mui/material";
import debounce from "lodash.debounce";
import config from "./config";

function AsyncSearchField({ value, onValueChange, style, isCreateNew }) {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const [inputValue, setInputValue] = useState("");

    useEffect(() => {
        if (value) {
            setInputValue(value);
            const existingOption = options.find((opt) => opt.name === value);
            setSelectedValue(existingOption || { name: value });
        } else {
            setInputValue("");
            setSelectedValue(null);
        }
    }, [value]);


    const findLeafNodesWithName = (data, searchStr) => {
        const result = [];
        function traverse(nodes) {
            nodes.forEach((node) => {
                if ((!node.children || node.children.length === 0) && node.name.includes(searchStr)) {
                    result.push(node);
                }
                if (node.children && node.children.length > 0) {
                    traverse(node.children);
                }
            });
        }
        if (data?.places?.list) {
            traverse(data.places.list);
        }
        return result;
    };

    const fetchOptions = (input) => {
        setLoading(true);
        fetch(`${config.app.serverUrl}/api/search-place/${input}`)
            .then((response) => response.json())
            .then((dataRes) => {
                const data=dataRes.data;
                const fetchedOptions = findLeafNodesWithName(data, input);
                setOptions(fetchedOptions);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                setLoading(false);
            });
    };

    const debouncedFetch = useMemo(() => debounce(fetchOptions, 500), []);

    const handleInputChange = (event, newInputValue, reason) => {
        if (reason === "input") {
            setInputValue(newInputValue);
            if (newInputValue) {
                debouncedFetch(newInputValue);
            } else {
                setOptions([]);
            }
        }
    };

    const handleSelectionChange = (event, newValue) => {
        setSelectedValue(newValue);
        setInputValue(newValue ? newValue.name : "");
        onValueChange(newValue ? newValue.name : "", newValue ? newValue._id : null);
    };

    const handleBlur = () => {
        const matchingOption = options.find((opt) => opt.name === inputValue);
        if (!matchingOption) {
            setInputValue(selectedValue ? selectedValue.name : inputValue);
        }
    };

    return (
        <Autocomplete
            options={options}
            loading={loading}
            value={selectedValue}
            inputValue={inputValue}
            onInputChange={handleInputChange}
            onChange={handleSelectionChange}
            onBlur={handleBlur}
            getOptionLabel={(option) => option?.name || ""}
            filterOptions={(x) => x}
            isOptionEqualToValue={(option, value) => option.name === value.name}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Place Name"
                    style={style}
                    variant="outlined"
                    InputLabelProps={{
                        shrink: !isCreateNew && true,

                    }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
            autoComplete={false}
            clearOnBlur={false}
        />
    );
}

export default AsyncSearchField;
